import barba from "@barba/core";

const removeSbiLightboxes = () => {

	const lightbox = document.getElementById('sbi_lightbox');
	if (lightbox) {
		lightbox.remove();
	}

	const lightboxOverlay = document.getElementById('sbi_lightboxOverlay');
	if (lightboxOverlay) {
		lightboxOverlay.remove();
	}

};

barba.hooks.beforeLeave(removeSbiLightboxes);
